import { DocumentCoverage } from 'dashboard/models/document-coverage';
import {
  DocumentCoverageActions,
  DocumentCoverageActionType,
} from 'dashboard/redux/actions/document-coverage';

export interface DocumentCoverageState {
  documentCoverage?: DocumentCoverage | undefined;
}

export const initialState: DocumentCoverageState = {
  documentCoverage: undefined,
};

const documentCoverageReducer = (
  state: DocumentCoverageState = initialState,
  action: DocumentCoverageActions,
): DocumentCoverageState => {
  switch (action.type) {
    case DocumentCoverageActionType.SetDocumentCoverage: {
      return {
        ...state,
        documentCoverage: action.payload.documentCoverage,
      };
    }

    default:
      return state;
  }
};

export default documentCoverageReducer;
